import { useContext } from 'react';
import { DispatchContext } from '../context/DispatchConext';

export const useDispatchWithFallback = (propsDispatch) => {
  const contextDispatch = useContext(DispatchContext);
  return propsDispatch || contextDispatch;
};